import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, SingleDate } from '@node-space/ui-components'
import type { DateErrorType, DateType } from '@node-space/ui-components'
import { useOnceOffExportContext } from 'hooks/context/useOnceOffExportContext'
import { useDateInput } from 'hooks/forms/useDateInput'

export const BalanceDateField = () => {
  const { t } = useTranslation()
  const dateInput = useDateInput()
  const { formValues, setValue } = useOnceOffExportContext()

  const [dateErrors, setDateErrors] = useState<DateErrorType>({
    day: false,
    month: false,
    year: false,
  })

  const handleBalanceDateChange = (date: DateType) => {
    const dateString = dateInput.setDateInputValue(date)
    const isEmptyDate = Object.values(date).every(field => field.trim() === '')
    setValue('balanceDate', isEmptyDate ? undefined : dateString)
  }

  return (
    <Box paddingL={12}>
      <SingleDate
        date={dateInput.getDateFields(formValues.balanceDate || '')}
        labels={{
          ...dateInput.singleDateLabels,
          date: t('exports.balanceDate'),
          errorMessage: dateInput.getDateErrorText(null),
        }}
        errors={dateErrors}
        onChange={handleBalanceDateChange}
        onValidate={(errors: DateErrorType) => setDateErrors(errors)}
      />
    </Box>
  )
}
